module.exports = __webpack_public_path__ + "static/media/new.05c14943.svg";